import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      zIndex: theme.zIndex.drawer + 1,
      "@media print": {
        display: "none",
      },
    },
    grow: {
      flexGrow: 1,
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        alignItems: "center",
        display: "flex",
      },
    },
    logoWrapper: {
      alignSelf: "stretch",
      flexShrink: 0,
      marginRight: theme.spacing(2),
      paddingTop: theme.spacing(1),
      width: theme.spacing(15),
    },
    menuButton: {
      marginLeft: theme.spacing(1),
    },
  })
);
